/**
 * @generated SignedSource<<2096812634ac4db7102f111552f3cac0>>
 * @relayHash 33d5cb864464856bfba034ce11494a6a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery } from './src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery.graphql';

const node: PreloadableConcreteRequest<src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a8abf8f0db8118c80c104d263cb9b57c8ed6264d060a8d429ffbcaa08ff96694",
    "metadata": {},
    "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
